var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
import { useSpring, animated, to } from '@react-spring/web';
import { interpolate } from 'flubber';
export var ChevronAnimatedIcon = function (props) {
  var _a;
  var rest = __rest(props, []);
  var direction = (_a = props.direction) !== null && _a !== void 0 ? _a : props.isActive ? "up" : "down";
  var startPath = "M64 31.6102L57.5314 38L32 12.7796L6.4457 38L-3.58088e-06 31.6102L32 -2.79753e-06L64 31.6102Z";
  var endPath = "M0 6.38981L6.46857 1.98027e-06L32 25.2204L57.5543 1.98027e-06L64 6.38981L32 38L0 6.38981Z";
  var pathValues = useSpring({
    from: {
      t: direction === "up" ? 1 : 0
    },
    to: {
      t: direction === "up" ? 0 : 1
    },
    config: {
      tension: 200,
      friction: 14
    }
  });
  // `interpolate` from flubber returns a function with a transition value "t" between 0 and 1
  // by animating between 0 and 1 via React spring, we can then use this interpolator to easily animate the path
  // without needing to know the actual point-math (flubber buest-guesses that for us).
  var interpolator = interpolate(startPath, endPath, {
    maxSegmentLength: 2
  });
  var t = useSpring({
    t: direction === "down" ? 1 : 0,
    config: {
      tension: 200,
      friction: 15
    }
  }).t;
  return React.createElement(SvgCircleIcon, __assign({}, rest, {
    glyphWidth: 64,
    glyphHeight: 38,
    variant: "glyph"
  }), React.createElement(animated.path, {
    d: to([pathValues.t], interpolator)
  }));
};